export const MERCH_DEPOSIT_ORDER_STATUS_CREATED = 'Created';
export const MERCH_DEPOSIT_ORDER_STATUS_PROCESSING = 'Processing';
export const MERCH_DEPOSIT_ORDER_STATUS_SUCCESS = 'Success';
export const MERCH_DEPOSIT_ORDER_STATUS_FAILED = 'Failed';
export const MERCH_DEPOSIT_ORDER_STATUS_UNKNOWN = 'Unknown';

export type IMerchDepositOrderStatus = typeof MERCH_DEPOSIT_ORDER_STATUS_CREATED
  | typeof MERCH_DEPOSIT_ORDER_STATUS_PROCESSING
  | typeof MERCH_DEPOSIT_ORDER_STATUS_SUCCESS
  | typeof MERCH_DEPOSIT_ORDER_STATUS_FAILED
  | typeof MERCH_DEPOSIT_ORDER_STATUS_UNKNOWN

export const getMerchDepositOrderStatus = (status: string) => {
  switch (status) {
    case MERCH_DEPOSIT_ORDER_STATUS_CREATED: return 'Created';
    case MERCH_DEPOSIT_ORDER_STATUS_PROCESSING: return 'Processing';
    case MERCH_DEPOSIT_ORDER_STATUS_SUCCESS: return 'Success';
    case MERCH_DEPOSIT_ORDER_STATUS_FAILED: return 'Failed';
    case MERCH_DEPOSIT_ORDER_STATUS_UNKNOWN: return 'Unknown';
    default: return status;
  }
}

export const getMerchDepositOrderStatusList = () => [
  { value: MERCH_DEPOSIT_ORDER_STATUS_CREATED, text: getMerchDepositOrderStatus(MERCH_DEPOSIT_ORDER_STATUS_CREATED) },
  { value: MERCH_DEPOSIT_ORDER_STATUS_PROCESSING, text: getMerchDepositOrderStatus(MERCH_DEPOSIT_ORDER_STATUS_PROCESSING) },
  { value: MERCH_DEPOSIT_ORDER_STATUS_SUCCESS, text: getMerchDepositOrderStatus(MERCH_DEPOSIT_ORDER_STATUS_SUCCESS) },
  { value: MERCH_DEPOSIT_ORDER_STATUS_FAILED, text: getMerchDepositOrderStatus(MERCH_DEPOSIT_ORDER_STATUS_FAILED) },
  { value: MERCH_DEPOSIT_ORDER_STATUS_UNKNOWN, text: getMerchDepositOrderStatus(MERCH_DEPOSIT_ORDER_STATUS_UNKNOWN) },
]
